import { createStyles, makeStyles } from '@material-ui/core';

import { colorVariables } from '../../../../styles/colorVariables';
import { Sizes } from '../../../../styles/sizes';
import vector from '../../../../assets/images/bg/vector.png';

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      padding: 0,
      width: '100%',
    },
    header: {
      color: colorVariables.userNavy,
      textAlign: 'left',
      fontSize: 24,
      fontWeight: 700,
      [theme.breakpoints.down(Sizes.mobile)]: {
        fontSize: 20,
      },
    },
    subHeader: {
      marginBottom: 12,
      color: colorVariables.userNavy,
      textAlign: 'left',
      fontSize: 20,
      fontWeight: 400,
      [theme.breakpoints.down(Sizes.mobile)]: {
        fontSize: 14,
        textAlign: 'center',
      },
    },
    card: {
      borderRadius: 10,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      border: '1px solid rgba(0,0,0,0.1)',
    },
    unlimitedCard: {
      borderRadius: 20,
    },
     cardContent: {
      padding: '0 !important',
      textAlign: 'left',
    },
    titleContainer: {
      backgroundColor: '#F1F2F8',
      padding: '10px 24px',
    },
    unlockEnterpriseContainer: {
      backgroundColor: '#F6F8FD',
    },
    unlimitedUpper: {
       backgroundColor: '#f0fdf4',
       textAlign: 'center',
       padding: '10px 24px',
    },
    upgradeButton: {
      marginTop: theme.spacing(3),
      padding: theme.spacing(1.5, 4),
      borderRadius: theme.shape.borderRadius * 5,
      fontWeight: 600,
      fontSize: '1rem',
      textTransform: 'none',
    },
    planTitleHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: theme.spacing(0.5),
    },
    planLabel: {
      fontSize: 12,
      fontWeight: 700,
      color: colorVariables.grey60,
      textTransform: 'uppercase',
    },
    trialBadge: {
      color: colorVariables.red80,
      fontSize: 14,
      fontWeight: 700,
    },
    mainPlanTitle: { 
      fontWeight: 700,
      fontSize: 22,
      marginBottom: 0,
      color: colorVariables.navy,
    },
    enterpriseTitle: {
      margin: '20px 0',
    },
    mainPlanSubTitle: {
      fontWeight: 400,
      fontSize: 16,
      color: colorVariables.navy,
      marginTop: 4,
    },
    bodyContainer: {
      textAlign: 'center',
      padding: 24,
    },
    cardFeatureTitle: {
      fontWeight: 700,
      fontSize: 18,
      marginBottom: theme.spacing(1),
      color: colorVariables.navy,
    },
    unlimitedCardFeatureTitle: {
      fontWeight: 600,
      fontSize: 16,
      color: colorVariables.navy,
    },
    cardText: {
      color: colorVariables.navy,
      fontSize: 16,
      fontWeight: 400,
      margin: '0 auto',
      marginBottom: theme.spacing(2),
    },
    unlockEnterpriseText: {
      width: '85%',
    },
    upgradeText: {
      fontWeight: 700,
      fontSize: 18,
      marginTop: theme.spacing(3),
      color: colorVariables.navy,
    },
    recommendedText: {
      color: '#40C369',
      fontWeight: 700,
      fontSize: 16,
      marginBottom: 2,
    },
    listItem: {
      paddingLeft: 0,
      paddingRight: 0,
    },
    listItemWrapper: {
      margin: '0 20px',
    },
    listItemIcon: {
      '&.MuiListItemIcon-root': {
        minWidth: 'auto',
        marginRight: theme.spacing(1),
      }
    },
    listItemText: {
      textAlign: 'left',
      '& .MuiListItemText-primary': {
        fontSize: 14,
        fontWeight: 400,
        color: colorVariables.navy,
      },
    },
    keepFeaturesContainer: {
      textAlign: 'center',
      marginTop: 30,
    },
    cardBox: {
      '&.MuiGrid-root': {
        [theme.breakpoints.up(Sizes.tablet)]: {
          maxWidth: '45%',
          flexBasis: '45%',
        },
      }
    },
    yourPlanCard: {
      backgroundImage: `url(${vector})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain',
    },
    unlimitedBox: {
      '&.MuiGrid-root': {
        [theme.breakpoints.up(Sizes.tablet)]: {
          maxWidth: '55%',
          flexBasis: '55%',
        },
      }
    },
    checkIcon: {
      color: '#40C369',
    },
    tabs: {
      display: 'flex',
      borderBottom: `1px solid ${colorVariables.steelGrey15}`,
      marginBottom: 24,
      marginTop: 24,
      [theme.breakpoints.down(Sizes.mobile)]: {
        marginTop: 10,
      },
    },
    tabLink: {
      display: 'block',
      width: 196,
      color: colorVariables.navy,
      fontSize: 14,
      lineHeight: '22px',
      textAlign: 'center',
      paddingBottom: 10,
      borderBottom: `3px solid ${colorVariables.transparent}`,
      marginBottom: -1,
      transition: 'all ease-in-out 0.2s',
      [theme.breakpoints.down(Sizes.mobile)]: {
        width: 'auto',
        marginRight: 8,
      },
    },
    tabLinkDisabled: {
      opacity: 0.5,
      cursor: 'default',
      pointerEvents: 'none',
    },
    tabLinkActive: {
      borderBottomColor: colorVariables.green,
      fontWeight: 700,
    },
    modalBox: {
      padding: 0,
      width: '70%',
      height: '600px',
      overflow: 'hidden',
      [theme.breakpoints.down(Sizes.mobile)]: {
        width: '90%',
        height: '450px',
        '& div': {
          padding: 0,
          margin: 0,
          maxWidth: '100%',
        },
      },
    },
    nextPaymentContainer: {
      textAlign: 'left',
    },
    nextPaymentText: {
      color: colorVariables.grey60,
      fontWeight: 400,
      fontSize: 16,
      '& strong': {
        color: colorVariables.navy,
        fontWeight: 600,
      }
    },
    changePlanText: {
      color: '#25A6EC',
      fontWeight: 600,
      fontSize: 14,
      cursor: 'pointer',
    },
    paymentFailedText: {
      textAlign: 'center',
      '& strong': {
        fontWeight: 700,
        color: colorVariables.red80,
      }
    },
    paymentFailedBtns: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginTop: 20,
    },
    paymentFailedContainer: {
      padding: '5px 24px 0'
    },
    ctaButton: {
      [theme.breakpoints.down(Sizes.mobile)]: {
        minWidth: '100%',
      },
    }
  }),
);
